<div class="modal">
  <div class="modal-overlay" (click)="cancel()"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <span class="ms-1 modal-title d-none"
          i18n="@@ProductAvailabilityNotifictionConfirmationDialogHeading">Availability
          Notification</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="cancel()"></i>
      </div>

      <div class="modal-body text-center m-5">
        <div class="availability-note fw-bold"
          i18n="@@ProductAvailabilityNotificationConfirmationDialogAvailabilityNote">Product being restocked</div>
        <div class="fs-4 fw-bold mt-3" i18n="@@ProductAvailabilityNotificationConfirmationDialogMessage">Would you like
          to be notified when the
          product is available again?</div>
        <button class="btn btn-secondary btn-pretty text-wrap my-3" (click)="confirm()"
          i18n="@@ProductAvailabilityNotificationConfirmationDialogConfirmButton">Yes, I would like to be alerted when
          the product is back in stock</button>
        <a class="c-pointer" (click)="decline()" i18n="@@ProductAvailabilityNotificationConfirmationDialogDecline">No,
          thank you</a>
      </div>

    </div>
  </div>
</div>
